import { Button, Typography, Box, styled } from "@mui/material";
import { ErrorOutline } from "@mui/icons-material";
import * as Sentry from "@sentry/react";
import { useEffect } from "react";

export default function ErrorBoundary() {
  useEffect(() => {
    Sentry.captureException(new Error("Error Boundary page rendered"));
  }, []);

  function reloadApp() {
    window.location.href = window.location.origin;
  }

  return (
    <StyledContainer>
      <StyledIcon />
      <StyledHeading variant="h6" display="block">
        Oops! Something went wrong.
      </StyledHeading>
      <StyledText>
        Try reloading the page, but if the issue persists, please contact
        support.
      </StyledText>
      <StyledButton variant="contained" color="default" onClick={reloadApp}>
        Reload
      </StyledButton>
    </StyledContainer>
  );
}

const StyledContainer = styled(Box)({
  position: "absolute",
  left: "0",
  right: "0",
  top: "0",
  bottom: "0",
  margin: "auto",

  display: "grid",
  gap: "24px",
  placeContent: "center",
  textAlign: "center",
  width: "380px"
});

const StyledHeading = styled(Typography)({
  margin: "0"
});

const StyledIcon = styled(ErrorOutline)({
  margin: "auto",
  fontSize: "48px"
});

const StyledText = styled(Typography)({
  color: "var(--teleforce-500)"
});

const StyledButton = styled(Button)({
  width: "150px",
  margin: "auto"
});
